import React, { useMemo } from 'react'
import BarComparisonChart from '../BarChart'
import { HeaderWapper, Heading, Wapper } from '../style'
import { monthNames } from '../../SalesDashboard'


//  Common helper to merge multiple datasets based on month & year.
//  Array of dataset objects: [{ key: 'enquiry', data: [...] }, { key: 'order', data: [...] }]
 
export const mergeChartData = (datasets = []) => {
	const map = new Map()

	datasets?.forEach(({ key, data }) => {
		data?.forEach((item) => {
			const keyId = `${item.year}-${item.month}`
			const existing = map.get(keyId) || {
				month: `${monthNames[item.month - 1]} ${item.year}`,
			}
			map.set(keyId, {
				...existing,
				[key]: item?.weight || 0,
			})
		})
	})

	// Sort chronologically (by year → month)
	return Array.from(map.values()).sort((a, b) => {
		const [aMonth, aYear] = a.month.split(' ')
		const [bMonth, bYear] = b.month.split(' ')
		const monthIndex = (m) => monthNames.indexOf(m)
		if (aYear === bYear) return monthIndex(aMonth) - monthIndex(bMonth)
		return parseInt(aYear) - parseInt(bYear)
	})
}

const EnquiryVsOrderChart = ({ EnquiryData = [], OrderData = [] }) => {
	const chartData = useMemo(
		() =>
			mergeChartData([
				{ key: 'enquiry', data: EnquiryData },
				{ key: 'order', data: OrderData },
			]),
		[EnquiryData, OrderData]
	)

	if (!chartData.length) return '-'

	return (
		<Wapper>
			<HeaderWapper>
				<Heading>Enquiry Vs Order</Heading>
			</HeaderWapper>
			<BarComparisonChart data={chartData} dataKeys={['enquiry', 'order']} colors={['#0043CE', '#4589FF']} />
		</Wapper>
	)
}

export default EnquiryVsOrderChart
